var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('chat-window',{attrs:{"current-user-id":_vm.currentUserId,"rooms":[
        {
          roomId: 1,
          roomName: _vm.complaintForm.user_name,
          index: 1,
          users: [
            {
              _id: _vm.complaintForm.user_code,
              username: _vm.complaintForm.user_name
            },
            {
              _id: _vm.currentUserId,
              username: 'Admin Isikulkas',
            },
            {
              _id: 12,
              username: 'Dummy',
            }
          ]
        }
      ],"messages":_vm.messages,"loadingRooms":_vm.loadingRooms,"messagesLoaded":_vm.messagesLoaded,"showFiles":_vm.showFiles,"isLoading":_vm.isLoading},on:{"open-file":_vm.openFile,"send-message":_vm.sendMessage}}),(_vm.isLoading)?_c('Loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }